export const toggleFollowMutation = /* GraphQL */ `
  mutation ToggleFollow($followeeID: ID!) {
    toggleFollow(followeeID: $followeeID) {
      id
      followersCount
      followingCount
    }
  }
`;

export const getUserFollowersQuery = /* GraphQL */ `
query GetUserFollowers($userID: ID!) {
  listFollows(filter: { followeeID: { eq: $userID } }) {
    items {
      id
      followerID
      followeeID
      createdAt
    }
  }
}
`;

export const getUserFollowingQuery = /* GraphQL */ `
query GetUserFollowing($userID: ID!) {
  listFollows(filter: { followerID: { eq: $userID } }) {
    items {
      id
      followerID
      followeeID
      createdAt
      followee {
        id
        username
        displayName
        avatar
      }
    }
  }
}
`;